export default {
  title: 'Absence Form',
  type: 'object',
  properties: {
    code: {
      type: 'string',
      format: 'string',
      title: 'Kod',
      fieldRequired: 'false',
      validationMessages: {
        required: 'Podaj kod'
      }
    },
    name: {
      type: 'string',
      format: 'string',
      title: 'Rodzaj nieobecności',
      fieldRequired: 'true',
      validationMessages: {
        required: 'Wpisz rodzaj nieobecności'
      }
    },
    isWorktime: {
      type: 'boolean',
      title: 'Czy liczyć weekendy?',
      fieldRequired: 'false',
      validationMessages: {
        required: 'Podaj czy liczyć nieobecność do czasu pracy'
      }
    },
    displayAsWorktime: {
      type: 'boolean',
      title: 'Ukryte',
      fieldRequired: 'false',
      validationMessages: {
        required: 'Podaj czy wyświetlać nieobecność jako czas pracy'
      }
    },
    isPaid: {
      type: 'boolean',
      title: 'Czy wyświetlać na podsumowaniu?',
      fieldRequired: 'false'
    },
    isHoliday: {
      type: 'boolean',
      title: 'Czy to są dni wliczane w urlop?',
      fieldRequired: 'false'
    }
  }
};
